var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.99414,116a23.99788,23.99788,0,0,0-4,47.6604V184a4,4,0,1,0,8,0V163.6604a23.99788,23.99788,0,0,0-4-47.6604Zm0,40a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,127.99414,156Zm80-72h-40V52a40,40,0,1,0-80,0V84h-40a12.01375,12.01375,0,0,0-12,12V208a12.01375,12.01375,0,0,0,12,12h160a12.01375,12.01375,0,0,0,12-12V96A12.01375,12.01375,0,0,0,207.99414,84Zm-112-32a32,32,0,1,1,64,0V84h-64Zm116,156a4.00458,4.00458,0,0,1-4,4h-160a4.00458,4.00458,0,0,1-4-4V96a4.00458,4.00458,0,0,1,4-4h160a4.00458,4.00458,0,0,1,4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1b67a80d4c85d62282677edda4b4646a.svg";
export { ForwardRef as ReactComponent };